import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const Authguard = ({ children }) => {
    const msisdn = useSelector((state) => state?.guard?.msisdn);
    const checksub = useSelector((state) => state?.guard?.checksub);
    let location = useLocation();

    if (!msisdn && location.pathname !== "/unauthorized") {
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  
    // Check subscription status
    if (msisdn !== null && msisdn !== undefined && msisdn !== "Not%20Found%0A" && checksub === 'new') {
      return <Navigate to="/subscription" state={{ from: location }} replace />;
    }
    if (msisdn !== null && checksub === 'active') {
      return children;
    }
    // If msisdn is available and subscription status is active, allow access
    return children;
};

export default Authguard;
